import { LocalStorageSessionStore } from './api/session';

export default new LocalStorageSessionStore();
